// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"P4-z","colorTextValue":"Q4-z","swatches":"R4-z","collapseLink":"S4-z","isCollapsed":"T4-z","dropdown":"U4-z","disabled":"V4-z"};